import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "radio-default--sprite",
  "use": "radio-default--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"radio-default--sprite\">\n    <rect width=\"14.75\" height=\"14.75\" x=\"5\" y=\"5\" fill=\"none\" stroke=\"#9A9EA0\" rx=\"7.375\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol